jQuery(document).ready(function($) {
  fetch('/cart.js', {
    method: 'GET',
    headers: {'Content-Type': 'application/json'}
  })
  .then(response => response.json())
  .then(data => {
    CartJS.init(data, {
      "dataAPI": true,
      "moneyFormat": window.moneyFormat,
      "moneyWithCurrencyFormat": window.moneyWithCurrencyFormat
    });
  }).catch((error) => {
    console.error('Error:', error);
  });

  jQuery(document).on('cart.ready', function(event, cart) {
    console.log("cart data", cart);
    window.dispatchEvent( new CustomEvent('cart-count-update', {'detail': {cartCount: cart.item_count }}) );
    window.dispatchEvent( new CustomEvent('cart-initiated', {'detail': {cart: cart }}) );
  });

  jQuery(document).on('cart.requestStarted', function(event, cart) {
    window.dispatchEvent( new CustomEvent('open-cart', {'detail': {open: true}}) );
    window.dispatchEvent( new CustomEvent('cart-loading', {'detail': {loading: true}}))
  });

  jQuery(document).on('cart.requestComplete', function(event, cart) {
    window.dispatchEvent( new CustomEvent('cart-request-complete', {'detail': {cart: cart, loading: false}}))
    window.dispatchEvent( new CustomEvent('cart-update', {'detail': {cart: cart, loading: false}}))
    window.dispatchEvent( new CustomEvent('cart-count-update', {'detail': {cartCount: cart.item_count }}) );

    const c = document.querySelector(".header__cart__status");
    if (c) { c.innerHTML = cart.item_count }

    if (cart.item_count == 1 && cart.total_price == 0) {
      CartJS.updateItem(1, 0);
      return;
    } 

    let pricyItems = 0;
    for (const item of cart.items) {
      if (item.price > 0) {
        pricyItems++;
      }
    }
    if (pricyItems == 0 && cart.item_count > 0) {
      CartJS.clear();
      return;
    }

    let n = 1;
    for (const item of cart.items) {
      if (item.price == 0 && item.quantity > 1) {
        CartJS.updateItem(n, 1)
        return;
      }
      n++;
    }
  });
  

  try {
    var url = new URL(window.location.href);
    if (url.searchParams.get('open_cart')) {
      window.dispatchEvent( new CustomEvent('open-cart', {'detail': {open: true}}) );
    } 
  } catch (e) {}
});